import { Injectable, signal } from "@angular/core";

export interface IUserSession {
  sub: string,
  name: string,
  email: string,
}

export interface IOrganization {
  id: string;
  name: string;
  address1: string;
  address2: string;
  city: string;
  post1: string;
  post2: string;
  state: string;
  country: string;
  vat: string;
}

export interface IUser {
  id: string;
  name: string;
  surname: string;
  email: string;
  role: string;
  verified: string;
  organizationId: string;
}


@Injectable({
  providedIn: 'root'
})
export class UserSessionService {
  public sub = signal<string>("x");
  public name = signal<string>("x");
  public email = signal<string>("x");

  public organization = signal<IOrganization|null>(null);
  public user = signal<IUser|null>(null)


  public setUserState(_state: IUserSession) {
    this.sub.set(_state.sub);
    this.name.set(_state.name);
    this.email.set(_state.email);
  }
}